import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Níor aimsíodh an leathanach',
  title: 'Níorbh fhéidir linn an leathanach sin a aimsiú',
  body: 'B’fhéidir go bhfuil an nasc as dáta, nó gur baineadh an leathanach. Inis dúinn cad atá á lorg agat agus aimseoimid é.',
  suggestionsTitle: 'B’fhéidir go bhfuil tú ag lorg',
  bestMatchTitle: 'An é seo a bhí i gceist agat',
  prefillHint: 'Líonta isteach ón seoladh a thriail tú',
  goHome: 'Baile',
  browseAll: 'Gach catagóir',
  reportBrokenLink: 'Tuairiscigh nasc briste',
  noticeTitle: 'Níl an leathanach sin ar fáil',
  noticeSearching: 'Ag cuardach {query} ina áit sin…',
  noticePrefilled: 'Cuardaigh {query} thíos, nó inis dúinn cad atá á lorg agat.',
  errorTitle: 'Chuaigh rud éigin amú',
  errorBody: 'Níorbh fhéidir linn an leathanach seo a lódáil. Bain triail eile as, nó cuardaigh an rud atá uait thíos.',
  retry: 'Bain triail eile as',
  streamLostTitle: 'Níorbh fhéidir linn an leathanach seo a chríochnú',
  streamLostBody: 'Stop an cuardach sular sábháladh an leathanach. Tosaigh arís é agus leanfaimid ar aghaidh ó na focail a scríobh tú.',
  relaunch: 'Cuardaigh arís',
};
